import getBlogImageUrl from "@Pages/Blog/utils/getBlogImageUrl";
import {
  SITE_URL,
  WEBSITE_ID,
  getContributorRef,
  getPersonNode,
  isPersonContributor,
  toSchemaGraph,
} from "@Pages/Blog/utils/blogSchemaGraph";
import extractPlainText from "./extractPlainText";

const DESCRIPTION_LIMIT = 160;

const truncate = (text: string): string => {
  if (text.length <= DESCRIPTION_LIMIT) return text;
  const cut = text.slice(0, DESCRIPTION_LIMIT);
  const breakAt = cut.lastIndexOf(" ");
  return `${cut.slice(0, breakAt > 0 ? breakAt : DESCRIPTION_LIMIT).trim()}…`;
};

const getAuthorMeta = (contributor: any, slug: string, lang?: string | null): any => {
  const name: string = contributor?.name || "";
  const role: string = contributor?.role || "";
  const bio = extractPlainText(contributor?.description).replace(/\s+/g, " ").trim();
  const description = truncate(
    bio ||
      `Student housing guides written and reviewed by ${name}${role ? `, ${role}` : ""} at amber.`,
  );
  const canonicalSuffix = `${lang ? `/${lang}` : ""}/blog/author/${slug}`;
  const image = contributor?.image?.url ? getBlogImageUrl(contributor.image.url) : undefined;
  const pageUrl = `${SITE_URL}${canonicalSuffix}`;
  const person = { ...contributor, slug };

  return {
    title: `${name}${role ? ` - ${role}` : ""} | Amber Blog`,
    description,
    keywords: [name, `${name} amber`, "amber blog author", "student housing expert"],
    canonical_url_suffix: canonicalSuffix,
    ...(image ? { ogImage: image } : {}),
    excludeSiteSchema: true,
    ...(isPersonContributor(person)
      ? {
          schemaData: toSchemaGraph([
            {
              "@type": "ProfilePage",
              "@id": `${pageUrl}#webpage`,
              url: pageUrl,
              name: `${name} | Amber Blog`,
              isPartOf: { "@id": WEBSITE_ID },
              ...(contributor?.createdAt ? { dateCreated: contributor.createdAt } : {}),
              ...(contributor?.updatedAt ? { dateModified: contributor.updatedAt } : {}),
              mainEntity: getContributorRef(person),
            },
            getPersonNode(person),
          ]),
        }
      : {}),
  };
};

export default getAuthorMeta;
